import { graphql } from '@generated/gql';

export const SEARCH_PHYSICAL_ADDRESS = graphql(/** GraphQL */ `
  query searchPhysicalAddress($input: SearchPhysicalAddressInput!) {
    searchPhysicalAddress(input: $input) {
      suggestions {
        id
        text
        next
      }
    }
  }
`);

export const FETCH_PHYSICAL_ADDRESS = graphql(/** GraphQL */ `
  query fetchPhysicalAddress($input: FetchPhysicalAddressInput!) {
    fetchPhysicalAddress(input: $input) {
      addressDetails {
        houseNumber
        unitNumber
        streetName
        city
        postal
        jurisdiction
        country
        neighborhood
        CountryIso2
        CountryIso3
        CountryName
        Province
        ProvinceCode
      }
    }
  }
`);
